// extracted by mini-css-extract-plugin
export default {"aboutPropertyDetail":"aboutPropertyDetail___saGzm","datailsBox":"datailsBox___rvBnJ","title":"title___pjX9C","time":"time___sAVQr","quetionContaner":"quetionContaner___vUmax"};